export const downloadFile = (ticketId: string) => {
  const downloadLink = document.createElement('a');
  downloadLink.href = `/api/resources/download/${ticketId}`;
  downloadLink.style.display = 'none';
  document.body.appendChild(downloadLink);
  downloadLink.click();

  setTimeout(() => {
    document.body.removeChild(downloadLink);
  }, 100);
};
